import { inject, Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { combineLatest, map, Observable } from 'rxjs';
import { PracticeLocationHeader } from 'src/modules/practice-location-header/models/practice-location-header';
import { HomeLocationState } from 'src/states';
import { UserLocationsListState } from 'src/states/user-locations-list/user-locations-list.state';
import { SelectedLocationType } from 'src/app/enums/selected-location-type.enum';
import { CurrentAccountState } from 'src/states/current-account/current-account.state';
import { CurrentLocationSettingsState } from 'src/states/current-location-settings/current-location-settings.state';
import { TimeZoneDto } from 'src/app/models/time-zone-dto';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class PracticeLocationHeaderService {
  private readonly store: Store = inject(Store);

  public readonly selectedLocationType$: Observable<SelectedLocationType | undefined> = this.store.select(CurrentAccountState.type);
  public readonly locationCode$: Observable<string | undefined> = this.store.select(CurrentAccountState.locationCode);
  public readonly locationName$: Observable<string | undefined> = this.store.select(CurrentAccountState.locationName);
  public readonly practiceName$: Observable<string | undefined> = this.store.select(CurrentAccountState.practiceName);
  public readonly userLocationsListLength$: Observable<number> = this.store.select(UserLocationsListState.userLocationsListLength);

  public readonly homeLocationName$: Observable<string | undefined> = this.store.select(HomeLocationState.locationName);

  public readonly timeZone$: Observable<TimeZoneDto> = this.store.select(CurrentLocationSettingsState.timeZone);

  public practiceLocationHeader$: Observable<PracticeLocationHeader> = combineLatest([
    this.selectedLocationType$,
    this.locationCode$,
    this.locationName$,
    this.practiceName$,
    this.userLocationsListLength$,
    this.homeLocationName$
  ]).pipe(
    map(([selectedLocationType, locationCode, locationName, practiceName, userLocationsListLength, homeLocationName]) => {
      const accountName = selectedLocationType === SelectedLocationType.PscHome ? homeLocationName : practiceName;

      return {
        type: selectedLocationType,
        locationCode: locationCode,
        locationName: locationName,
        practiceName: practiceName,
        accountName: accountName,
        showLocationSwitchLink: userLocationsListLength > 1
      } as PracticeLocationHeader;
    })
  );
}
